/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import BoletoService from "../../modules/services/BoletoService";
import { GoArrowRight } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import "../css/cardBoletos.css";

function BoletoCard({ cliente, onBoletoVencido }) {
    const [error, setError] = useState("");
    const [totalVencido, setTotalVencido] = useState(0);
    const [totalVencer, setTotalVencer] = useState(0);
    const navigate = useNavigate(); // Hook para navegação

    useEffect(() => {
        const fetchTotais = async () => {
            try {
                const { totalVencido } = await BoletoService.getTitulosVencidos(
                    cliente.cdCliente
                );
                setTotalVencido(totalVencido);

                if (totalVencido > 0) {
                    onBoletoVencido(true); // Notifica o dashboard que existem boletos vencidos
                } else {
                    onBoletoVencido(false);
                }

                const { totalVencer } = await BoletoService.getTitulosVencer(
                    cliente.cdCliente
                );
                setTotalVencer(totalVencer);
            } catch (err) {
                setError("Erro ao carregar as notificação");
            }
        };

        fetchTotais();
    }, [cliente.cdCliente, onBoletoVencido]);

    // Função para navegar para a página de boletos com o filtro de "A Vencer"
    // Função para calcular a data de amanhã e formatar corretamente
    // Função para pegar a data de amanhã como objeto Date
    const getAmanhaData = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow; // Retorna o objeto Date diretamente
    };

    // Função para navegar para a página de boletos com o filtro de "Vencendo amanhã"
    const handleVencendoAmanhaClick = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const formattedTomorrow = `${tomorrow.getFullYear()}-${(
            tomorrow.getMonth() + 1
        )
            .toString()
            .padStart(2, "0")}-${tomorrow
                .getDate()
                .toString()
                .padStart(2, "0")}T24:00:00.000Z`;

        console.log("Enviando filtros para Vencendo Amanhã:", {
            dtVencimentoDe: formattedTomorrow,
            dtVencimentoAte: formattedTomorrow,
            situacaoIn: ["AVENCER"],
        });

        navigate("/boletos", {
            state: {
                dtVencimentoDe: formattedTomorrow,
                dtVencimentoAte: formattedTomorrow,
                situacaoIn: 0,
            },
        });
    };

    const handleAVencerClick = () => {
        navigate("/boletos", { state: { situacaoIn: 0 } });
    };

    const handleVencidosClick = () => {
        navigate("/boletos", { state: { situacaoIn: ["VENCIDO"] } });
    };

    return (
        <div className="card bills-card">
            <div className="bills-header">
                <h3 className="titulo">Boletos</h3>
                <a
                    href="#"
                    className="vencendo-amanha-link"
                    onClick={handleVencendoAmanhaClick}
                >
                    Vencendo amanhã <GoArrowRight />
                </a>
            </div>

            {/* Container para os boletos */}
            <div className="bills-container">
                {/* Boleto a vencer */}
                <div className="bills">
                    <div className="bills-info a-vencer">
                        <div className="bill-details">
                            <div className="bill-status">
                                <span>A vencer</span>
                            </div>
                            <div className="bill-value">
                                <span>
                                    {totalVencer
                                        ? `R$ ${totalVencer.toLocaleString(
                                            "pt-BR",
                                            { minimumFractionDigits: 2 }
                                        )}`
                                        : "R$ 0,00"}
                                </span>
                            </div>
                        </div>
                        <div className="bill-link">
                            <a href="#" onClick={handleAVencerClick}>
                                Ver <GoArrowRight />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Boleto vencido */}
                <div className="bills-info vencidos">
                    <div className="bill-details">
                        <div className="bill-status vencido">
                            <span>Vencidos</span>
                        </div>
                        <div className="bill-value">
                            <span>
                                {totalVencido
                                    ? `R$ ${totalVencido.toLocaleString(
                                        "pt-BR",
                                        { minimumFractionDigits: 2 }
                                    )}`
                                    : "R$ 0,00"}
                            </span>
                        </div>
                    </div>
                    <div className="bill-link">
                        <a href="#" onClick={handleVencidosClick}>
                            Ver <GoArrowRight />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BoletoCard;
